import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ZoomService {
  private _zoomLevel = 100;
  private zoomTimeout: any;

  get zoomLevel() {
    return this._zoomLevel;
  }

  setZoomLevel(zoomLevel: number) {
    if (Number.isNaN(zoomLevel) || zoomLevel < 50 || zoomLevel > 200) {
      return;
    }

    this._zoomLevel = zoomLevel;

    this.applyCurrentZoomLevel();
    localStorage.setItem('zoomLevel', zoomLevel.toString());
  }

  applyCurrentZoomLevel() {
    if (this.zoomTimeout) {
      clearTimeout(this.zoomTimeout);
    }
    this.zoomTimeout = setTimeout(() => {
      const scale = this._zoomLevel / 100;
      document.documentElement.style.fontSize = `${14 * scale}px`;
      const root = document.documentElement;
      root.style.setProperty('--row-height', `${20 * scale}px`);
      root.style.setProperty('--header-height', `${18 * scale}px`);
      root.style.setProperty('--cell-padding-vertical', `${6 * scale}px`);
      root.style.setProperty('--cell-padding-horizontal', `${8 * scale}px`);
      root.style.setProperty('--font-size', `${16 * scale}px`);
    }, 0);
  }
}
